import React, { useContext, useState } from "react";
import { wkdays } from "../../../../../enums";
import { LanguageContext } from "../../../../../Context";
import ClassesOnDay from "./ClassesOnDay";
import FreeTime from "./FreeTime";
import useDBO from "../../../hooks/useDBO";
import Loading from "../../../Loading";
import Error from "../../../components/Error";
import AddButton from "../../../components/AddButton";
import NewClassDialog2 from "../NewClassDialog2";


export default function Classes(props) {
const {location,search, teacherFilter,status, week, setT} = props;
const {language} = useContext(LanguageContext)
const classes = useDBO(`/class-timetable/${week}/${location._id}/${status}`,undefined,[],(classes)=>setT([...classes.map(c=>c.teacher),...classes.map(c=>c.foreignTeacher)]));
const [open, setOpen] = useState(false);
   
  if (classes.loading) return <Loading />
  if (classes.error) return <Error />
  console.log(classes)

  
return (
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      width: "100%",
      padding: 0,
      margin: 0,
      overflowY: "scroll",
    }}
  >
    {" "}
    {wkdays.map((day, i) => (
      <div
        key={i}
        style={{ flexGrow: 1, flexBasis: 1, marginLeft: 2 }}
      >
        <div style={{ textAlign: "center", padding: 2, fontSize: 14 }}>
          {day.name[language]}
        </div>
        {status !== "Free time" ? (
          <ClassesOnDay
            day={day.day}
            location={location}
            search={search}
            teacherFilter={teacherFilter}
            week={week}
            classes={classes.filter(
              (c) =>
                c.location === location._id &&
                c.status === status &&
                c.dayOfWeek === day.day
            )}
            setClasses={classes.set}
            update={classes.update}
            replace={classes.replace}
          />
        ) : (
          <FreeTime day={i} />
        )}
      </div>
    ))}{" "}
    <AddButton
      action={() => setOpen(true)}
      tooltip="New Class"
      className="float-right"
    />
    <NewClassDialog2
      open={open}
      setOpen={setOpen}
      week={week}
      setClasses={classes.set}
    />
  </div>
);
}